<template>
  <div>
    <vue-headful title="Reset Password" />
    <Header page_title="Reset Password" />
    <div class="d-flex min-height align-items-center">
      <div class="container-fluid px-4 mx-2">
        <form class="mt-5" @submit.prevent="onSubmit">
          <p>Please enter your email address, we will send the link.</p>
          <div class="form-group mb-4 pb-1">
            <input
              type="email"
              class="form-control"
              placeholder="E-mailadres"
              v-model="form.email"
              autocomplete="nope"
              required
            />
          </div>
          <button type="submit" class="btn btn-warning btn-block">
            Send reset instructions
          </button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      form: {
        email: ""
      },
      success: false,
      error: false
    };
  },
  created() {
    // fetch the data when the view is created and the data is
    // already being observed
    this.fetchData();
  },
  watch: {
    // call again the method if the route changes
    $route: "fetchData"
  },
  methods: {
    fetchData() {
      // do whatever
    },
    onSubmit: function() {
      this.error = this.success = false;
      let formData = new FormData();
      formData.append("email", this.form.email);

      var url = this.$apiURI + "/auth/reset";
      this.$http
        .post(url, formData, {
          headers: {
            Accept: "application/json"
          }
        })
        .then(resp => {
          if (resp) {
            this.success = resp.data;
          }
        })
        .catch(err => {
          if (err) {
            this.error = err.response.data;
          }
        });
    }
  }
};
</script>

<style scoped></style>
